<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12" lg="4">
        <b-card :header="caption">
          <b-row>
            <b-col cols="6">
              <b-form-group label="Name">
                <b-form-input type="text" class="form-control" v-model="menu.name" />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Recording">
                <b-select :options="recordingOptions" v-model="menu.recordingId"></b-select>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group class="mb-0">
                <label for="timeout">Timeout</label>
                <b-input-group append="ms">
                  <b-form-input type="text" id="timeout" v-model="menu.timeout"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6" class="mt-4">
              <b-checkbox v-model="menu.hasExtensionDialing">Can Dial Extensions</b-checkbox>
            </b-col>
          </b-row>
          <template slot="footer">
            <b-btn size="sm" variant="primary" @click="save">Save</b-btn>
            <b-btn class="ml-1" size="sm" variant="danger" @click="del">Delete</b-btn>
          </template>
        </b-card>
      </b-col>
      <b-col cols="12" lg="8">
        <b-card border-variant="primary" header-bg-variant="primary" header-text-variant="white" header="Menu Options">
          <menu-options v-model="menu.options"></menu-options>
        </b-card>
      </b-col>
    </b-row>
    <add-menu-option-modal @add="addOption" :menuId="menu.id" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MenuOptions from './partials/MenuOptions.vue'
import AddMenuOptionModal from './partials/AddMenuOption.vue'

export default {
  name: 'CallMenu',
  components: {
    AddMenuOptionModal,
    MenuOptions,
  },
  computed: {
    ...mapGetters({
      account: 'global/account',
      menus: 'account/menus',
      recordings: 'account/recordings'
    }),
    recordingOptions () {
      if (!this.recordings) return []
      return this.recordings.map(o => ({ value: o.id, text: o.name }))
    },
    attrs () {
      return [
        {
          key: 'today',
          dot: true,
          dates: new Date(),
        }
      ]
    }
  },
  data () {
    return {
      caption: 'Menu',
      menu: {
        id: null,
        name: null,
        recordingId: null,
        timeout: 5000
      },
      optionNumber: null,
      inboundRoutes: [],
    }
  },
  methods: {
    routeUpdate (type, index, data) {
      if (type === 'save') {
        if (index >= 0) {
          this.$set(this.inboundRoutes, index, data)
        }
      } else if (type === 'delete') {
        this.inboundRoutes.splice(index, 1)
      }
    },
    sortUpdate (routes) {
      this.inboundRoutes = routes
    },
    async addOption () {
      const { data } = await this.$axios.get(`/v1/menus/${this.menu.id}`)
      this.menu = data

    },
    async save () {
      const id = this.$route.params.id

      const { data } = await this.$axios.put(`/v1/menus/${id}`, this.menu)
      Object.assign(this.menu, data)
      // await this.$store.dispatch('account/getMenus')
    },
    del () {

    },
    async getMenu (id) {
      const menu = this.menus.find(o => o.id == id)
      if (menu) this.menu = menu
      const { data } = await this.$axios.get(`/v1/menus/${id}`)
      this.menu = data
    },
    // async getRoutes(id) {
    //   const { data } = await this.$axios.get(`/v1/routes?profileId=${id}`)
    //   this.inboundRoutes = data
    // }
  },
  created () {
    this.getMenu(this.$route.params.id)
    // this.getRoutes(this.$route.params.id)
  },
}
</script>


